import { render, staticRenderFns } from "./InputRichText.vue?vue&type=template&id=450c506e&scoped=true&"
import script from "./InputRichText.vue?vue&type=script&lang=js&"
export * from "./InputRichText.vue?vue&type=script&lang=js&"
import style0 from "./InputRichText.vue?vue&type=style&index=0&id=450c506e&scoped=true&lang=css&"
import style1 from "./InputRichText.vue?vue&type=style&index=1&id=450c506e&lang=scss&scoped=true&"
import style2 from "./InputRichText.vue?vue&type=style&index=2&id=450c506e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450c506e",
  null
  
)

export default component.exports